<template>
  <div>
    <div class="title-container">
      <h1 class="title">{{ this.selectedDashboard }} POs</h1>
      <div style="width: 33%;">
        <b-field class="sort-container" custom-class="shrink-0 m-0" label="View: ">
          <b-select expanded v-model="selectedDashboard" placeholder="Select" style="width: 100%;">
              <option
                  v-for="option in dashboardFields"
                  :value="option"
                  :key="option"
              >
                  {{ option}}
              </option>
          </b-select>
        </b-field>
      </div>
    </div>
    
    <form @submit.prevent="loadData">
      <b-field>
        <button type="button" class="info-button" @click.stop="showFindInstructions = !showFindInstructions">
          <b-icon icon="info" size="is-small" />
          <b-notification
            v-model="showFindInstructions"
            :active="showFindInstructions"
            aria-close-label="Close notification"
            class="info-popover"
        >
            <div class="instructions-container">
              <h5 class="instruction-header">Date Searching Instructions</h5>
              <h1 class="instructions-item">Operator</h1>
              <h1 class="instructions-item">Instruction</h1>
             
              <!-- <span class="instruction-operator"><</span>
              <div class="instruction-item-container">
                <span>Less than. Example:</span>
                <span class="instructions-item">
                  {{ "<04/30/2026 finds POs with an order date that is before 04/30/2026" }}
                </span>
              </div>

              <span class="instruction-operator"><=</span>
              <div class="instruction-item-container">
                <span>Less than or equal to. Example:</span>
                <span class="instructions-item">
                  {{ "<=04/30/2026 finds POs with an order date that is before or on 04/30/2026" }}
                </span>
              </div>

              <span class="instruction-operator">></span>
              <div class="instruction-item-container">
                <span>Greater than. Example:</span>
                <span class="instructions-item">
                  {{ ">04/01/2026 finds POs with an order date that is after 04/01/2026" }}
                </span>
              </div>

              <span class="instruction-operator">>=</span>
              <div class="instruction-item-container">
                <span>Greater than or equal to. Example:</span>
                <span class="instructions-item">
                  {{ ">=04/01/2026 finds POs with an order date that is after or on 04/01/2026" }}
                </span>
              </div> -->

              <span class="instruction-operator">...</span>
              <div class="instruction-item-container">
                <span>Range. Example:</span>
                <span class="instructions-item">
                 {{ "04/01/2026...04/30/2026 finds POs with an order date that is between 04/01/2026 and 4/30/2026" }}
                </span>
              </div>

              <span class="instruction-operator">//</span>
              <div class="instruction-item-container">
                <span>Today's date. Example:</span>
                <span class="instructions-item">
                  {{ "// finds POs with an order date that matches exactly today's date" }}
                </span>
              </div>

              <span class="instruction-operator">*</span>
              <div class="instruction-item-container">
                <span>Zero or more characters. Example:</span>
                <span class="instructions-item">
                  {{ "*/01/2026 finds POs with an order date of 01/01/2026, 02/01/2026, ..., 12/01/2026" }}
                </span>
              </div>
            </div>
          </b-notification>
        </button>
        <b-input expanded :placeholder="`Search ${this.selectedDashboard} POs...`" v-model="search" rounded icon="search"></b-input>
        <span v-if="search" class='control'>
            <button class="button is-rounded" type="button" @click='clear'>Clear</button>
        </span>
      </b-field>
      <!--<b-input placeholder="Search Unreceived POs..." v-model="search" rounded type="search" icon="search"></b-input>-->
    </form>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <b-table 
      :data="orderData" 
      narrowed 
      default-sort="poNumber"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      default-sort-direction="desc"
    >
      <template slot-scope="props">
        <b-table-column label="PO #" sortable field="poNumber">
          {{props.row.poNumber}}
        </b-table-column>
        <b-table-column label="Vendor Name" sortable field="vendorName">
          {{props.row.vendorName}}
        </b-table-column>
        <b-table-column label="Purchasing Agent" sortable field="purchasingAgent">
          {{props.row.purchasingAgent}}
        </b-table-column>
        <b-table-column label="Date Ordered" sortable field="orderDate">
          {{props.row.orderDate}}
        </b-table-column>
        <b-table-column label="Invoice Total" sortable field="zcnTotalAmountDue">
          $ {{props.row.zcnTotalAmountDue.toLocaleString()}}
        </b-table-column>
        <b-table-column label="">
            <button class="button is-info" @click="receive(props.row.__kptID)">{{ props.row.isReceived == 1 ? "View" : "Edit/Receive" }}</button>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
// import store from '../../store/store.js';
// adding comment so build script works? 
export default {
  name: 'UnreceivedPOs',
  props: ['data'],
  data () {
    return {
      orderData: [],
      isLoading: false,
      isFullPage: false,
      search: "",
      sortFields: ['PO #', 'Vendor Name', 'Date Ordered', 'Invoice Total'],
      dashboardFields: [],
      selectedFilterField: '',
      selectedDashboard: 'Unreceived',
      viewReceivedPOs: false,
      showFindInstructions: false
    };
  },
  computed:{
    ...mapState([
        'userInfo',
    ]),
    sort: function(){
      if(this.selectedFilterField == ""){
        return [
          {
            "fieldName": "zctSortPoNumber",
            "sortOrder": "descend"
          }
        ];
      }
      if(this.selectedFilterField === 'PO #'){
        return[
          {
            "fieldName": "zctSortPoNumber",
            "sortOrder": "descend"
          }
        ];
      }
      if(this.selectedFilterField === 'Vendor Name'){
        return[
          {
            "fieldName": "vendorName",
            "sortOrder": "ascend"
          }
        ];
      }
      // if(this.selectedFilterField === 'Purchasing Agent'){
      //   return[{
      //     "fieldName": "purchasingAgent",
      //     "sortOrder": "ascend"
      //   }];
      // }
      if(this.selectedFilterField === 'Date Ordered'){
        return[
          {
            "fieldName": "orderDate",
            "sortOrder": "ascend"
          }
        ];
      }
      if(this.selectedFilterField === 'Invoice Total'){
        return[
            {
            "fieldName": "zcnTotalAmountDue",
            "sortOrder": "ascend"
          }
        ];
      }
 
    },
    queryAll: function(){
      let searchArray = []
      
      if(this.userInfo.canViewAllPlanarPOs && this.userInfo.canViewAllLogPOs) {
        if(this.search == ""){
          return [
            {
              "poNumber" : "*",
              "purchasingAgent": "*"
            }
          ];
        }
        searchArray = [
          {
            "poNumber": this.search,
            "purchasingAgent": "*"
          },
          {
            "vendorName": this.search,
            "purchasingAgent": "*"
          },
          {
            "department": this.search,
            "purchasingAgent": "*"
          },
          {
            "purchasingAgent": this.search
          },
          {
            "zcnTotalAmountDue": this.search,
            "purchasingAgent": "*"
          },
          {
            "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
            "purchasingAgent": "*"
          },
        ]
        
        // Only search on order date if search won't throw validation error
        if(this.isValidSearchForDate()){
          searchArray.push({
            "orderDate": this.search,
            "purchasingAgent": "*"
          })
        }

        return searchArray
      } else if (this.userInfo.canViewAllPlanarPOs) {
        if(this.search == ""){
          return [
            {
              "poNumber" : "P*",
              "purchasingAgent": "*"
            }
          ];
        }
        
        searchArray = [
          {
            "poNumber": "P" + this.search,
            "purchasingAgent": "*"
          },
          {
            "poNumber": "P*",
            "vendorName": this.search,
            "purchasingAgent": "*"
          },
          {
            "poNumber": "P*",
            "department": this.search,
            "purchasingAgent": "*"
          },
          {
            "poNumber": "P*",
            "purchasingAgent": this.search
          },
          {
            "poNumber": "P*",
            "zcnTotalAmountDue": this.search,
            "purchasingAgent": "*"
          },
          {
            "poNumber": "P*",
            "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
            "purchasingAgent": "*"
          },
        ]

        // Only search on order date if search won't throw validation error
        if(this.isValidSearchForDate()){
          searchArray.push({
            "poNumber": "P*",
            "orderDate": this.search,
            "purchasingAgent": "*"
          })
        }

        return searchArray
      } else if (this.userInfo.canViewAllLogPOs) {
        if(this.search == ""){
          return [
            {
              "poNumber" : "*",
              "purchasingAgent": "*"
            },
            {
              "poNumber" : "P*",
              "omit": "true"
            }
          ];
        }

        searchArray = [
          {
            "poNumber": this.search,
            "purchasingAgent": "*"
          },
          {
            "vendorName": this.search,
            "purchasingAgent": "*"
          },
          {
            "department": this.search,
            "purchasingAgent": "*"
          },
          {
            "purchasingAgent": this.search
          },
          {
            "zcnTotalAmountDue": this.search,
            "purchasingAgent": "*"
          },
          {
            "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
            "purchasingAgent": "*"
          }
        ]

        // Only search on order date if search won't throw validation error
        if(this.isValidSearchForDate()){
          searchArray.push({
            "orderDate": this.search,
            "purchasingAgent": "*"
          })
        }

        searchArray.push({
          "poNumber": "P*",
          "omit": "true"
        })
        
        return searchArray
      }
    },
    query: function(){
      let searchArray = []

      if(this.search == ""){
        return [
          {
            "poNumber" : "*",
            "isReceived": this.viewReceivedPOs ? "1" : "=",
            "purchasingAgent": this.userInfo.employeeName
          },
          {
            "poNumber" : "*",
            "isReceived": this.viewReceivedPOs ? "1" : "==0",
            "purchasingAgent": this.userInfo.employeeName
          }
        ];
      }
      searchArray = [
        {
          "poNumber": this.search,
          "isReceived": this.viewReceivedPOs ? "1" : "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "vendorName": this.search,
          "isReceived": this.viewReceivedPOs ? "1" : "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "department": this.search,
          "isReceived": this.viewReceivedPOs ? "1" : "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        // {
        //   "isReceived": this.viewReceivedPOs ? "1" : "=",
        //   "purchasingAgent": this.search
        // },
        {
          "zcnTotalAmountDue": this.search,
          "isReceived": this.viewReceivedPOs ? "1" : "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
          "isReceived": this.viewReceivedPOs ? "1" : "=",
          "purchasingAgent": this.userInfo.employeeName
        },
      ];

      // Only search on order date if search won't throw validation error
      if(this.isValidSearchForDate()){
        searchArray.push({
          "orderDate": this.search,
          "isReceived": this.viewReceivedPOs ? "1" : "=",
          "purchasingAgent": this.userInfo.employeeName
        })
      }

      return searchArray
    },
    searchQuery: function(){
      let queryArray = []
      if(this.selectedDashboard === 'All' && (this.userInfo.canViewAllPlanarPOs || this.userInfo.canViewAllLogPOs)) {
        queryArray = [ ...this.queryAll ]
      } else {
        queryArray = [ ...this.query ]
      }
      
      var searchQuery = {
          "query": queryArray,
          "sort": this.sort
      };
      return searchQuery;
    }
  },
  watch:{
    selectedFilterField(newValue, oldValue){
      if (newValue !== oldValue && newValue !== '') {
        this.loadData()
      }
    },
    selectedDashboard(newValue, oldValue){
      switch(newValue){
        case 'Unreceived':
          this.viewReceivedPOs = false
          break
        case 'All':
          this.viewReceivedPOs = false
          break
        case 'Received':
          this.viewReceivedPOs = true
          break
        default:
          break
      }
      this.orderData = []
      this.loadData()
    }
  },
  created: function() {
    this.dashboardFields = (this.userInfo.canViewAllPlanarPOs || this.userInfo.canViewAllLogPOs) ? ['Unreceived', 'Received', 'All'] : ['Unreceived', 'Received']
    this.selectedDashboard = (this.userInfo.canViewAllPlanarPOs || this.userInfo.canViewAllLogPOs) ? 'All' : 'Unreceived'
    this.loadData();
  },
  methods: {
    ...mapMutations([
      'updateNewPoNumber'
    ]),
    
    // Loads unreceived POs from FileMaker
    loadData: function(){
      this.isLoading = true;
      var self = this;
      this.$http.post('api/v2/find.php?layout=purchaseOrder-dashboard-list', this.searchQuery)
      .then( response => {
          // if (window.location.href.includes('localhost')) {
          //   response.data = JSON.parse(response.data.split('\n')[response.data.split('\n').length - 1])
          // }
          if(response.data.messages[0].code === "401"){
              this.$toast.open(response.data.messages[0].message);
              self.isLoading = false;
              return;
          }
          if(response.data.messages[0].code != 0){
              this.$toast.open(response.data.messages[0].message);
              self.isLoading = false;
              return;
          }
          self.orderData = [];
          response.data.response.data.forEach(function(record){
              self.orderData.push(record.fieldData);
          });

          self.isLoading = false;
      })
      .catch( error => {
          if (error.response) {
              this.$toast.open(error.response.status);
          } 
          else {
              this.$toast.open("Unknown Error");
          }
          self.isLoading = false;
      });
    },
    
    // Goes to the edit/receive page for the selected PO
    receive: function(orderID){
      this.$router.push({name: 'PurchaseOrderReceivePage', params: { id: orderID }});
    },

    // FileMaker will throw a date validation error if the search is not in a proper format for a date field
    // Use the regex to validate that the search will work in a date field before adding to find request
    isValidSearchForDate(){
      const DATE_VALIDATION_REGEX = /^(?:[<>]=?)?(?:\*|\/\/|\d{4}|(?:[\d*]+[/-][\d*]+(?:[/-][\d*]+)?))(?:\.\.\.(?:[\d*]+[/-][\d*]+(?:[/-][\d*]+)?))?$/
      return DATE_VALIDATION_REGEX.test(this.search)
    },

    toggleReceivingView: function(){
      this.viewReceivedPOs = !this.viewReceivedPOs;
      this.loadData();
    },
    
    clear: function(){
      this.search = "";
      this.loadData();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button {
    background-color: #d00a0b;
    color: white;
    width: 116px;
  }

  .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-bottom: 1.5rem;
  }

  .sort-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
  }

  .title {
    margin: 0 !important;
  }

  .info-button {
    position: relative;
    border-color: #DBDBDB;
    border-width: 1px;
    border-radius: 4px 0px 0px 4px;
  }

  .info-button:hover {
    cursor: pointer;
  }

  .info-popover {
    position: absolute;
    top: 2rem;
    width: 50dvw;
    z-index: 99;
  }

  .info-popover:hover {
    cursor: default;
  }

  .instructions-container {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 1rem;
  }

  .instruction-header {
    grid-column: 1 / -1;
    font-weight: 700;
    font-size: 20px;
  }

  .instructions-item {
    display: flex;
  }

  .instruction-item-container {
    display: flex;
    flex-direction: column;
    grid-column: span 1;
  }

  .instruction-operator {
    grid-column: span 1;
    text-align: center;
    align-self: center;
  }
</style>

<style>
  .shrink-0 {
    flex-shrink: 0;
  }

  .m-0 {
    margin: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/UnreceivedPOs.vue